export default {
  authUser(state, data) {
    state.token = data.token;
  },

  setLoginCheck(state, data) {
    state.loginCheck = data;
  },

  setForgotCheck(state, data) {
    state.forgotCheck = data;
  },
  setForgotBtn(state, data) {
    state.forgotBtn = data;
  },

  setCurrentUser(state, data) {
    state.userProfile = data;
  },

  clearAuth(state) {
    state.token = null;
  },

  setUserSession(state, data) {
    state.userSession = data;
  },

  setErrorMessage(state, data) {
    state.errorMessage = data;
  },

  setModalVisibility(state, data) {
    state.modalVisibility = data;
  },

  setBreadcrumbs(state, data) {
    state.breadcrumbs = data;
  },

  saveTabState(state, { tabName, data }) {
    state.tabsData[tabName] = {
      ...data,
      savedAt: new Date().toISOString(),
    };
  },

  // بازیابی state یک تب
  loadTabState(state, tabName) {
    return state.tabsData[tabName];
  },

  // اضافه کردن تب به لیست فعال
  addActiveTab(state, tabName) {
    if (!state.activeTabs.includes(tabName)) {
      state.activeTabs.push(tabName);
    }
  },

  // حذف تب از لیست فعال
  removeActiveTab(state, tabName) {
    state.activeTabs = state.activeTabs.filter((t) => t !== tabName);
    delete state.tabsData[tabName];
  },

  // حذف تمام تب‌ها
  clearAllTabs(state) {
    state.tabsData = {};
    state.activeTabs = [];
  },

  // حذف تب‌های بسته شده
  clearClosedTabs(state, keepTabs) {
    const closedTabs = state.activeTabs.filter((t) => !keepTabs.includes(t));
    closedTabs.forEach((tab) => {
      delete state.tabsData[tab];
    });
    state.activeTabs = keepTabs;
  },

  // Alert Handles ---------------------------------------

  setPostCheck(state, data) {
    state.postCheck = data;
  },

  setPostCheck2(state, data) {
    state.postCheck2 = data;
  },

  setPostCheckHeader(state, data) {
    state.postCheckHeader = data;
  },

  setPostCheckFiscalYear(state, data) {
    state.postCheckFiscalYear = data;
  },

  setInfo(state, data) {
    state.checkAlert = 4;
    state.infoMessage = data;
    state.infoMessage = state.infoMessage.split("</br>").join("\n");
    state.infoMessage = state.infoMessage.split("<br/>").join("\n");
    state.infoMessage = state.infoMessage.split("<br>").join("\n");
  },

  setWarning(state, data) {
    state.checkAlert = 3;
    state.warningMessage = data;
    state.warningMessage = state.warningMessage.split("</br>").join("\n");
    state.warningMessage = state.warningMessage.split("<br/>").join("\n");
    state.warningMessage = state.warningMessage.split("<br>").join("\n");
  },

  setError(state, data) {
    state.checkAlert = 2;
    state.dangerMessage = data;
    state.dangerMessage = state.dangerMessage.split("</br>").join("\n");
    state.dangerMessage = state.dangerMessage.split("<br/>").join("\n");
    state.dangerMessage = state.dangerMessage.split("<br>").join("\n");
  },

  setSuccess(state, data) {
    state.checkAlert = 1;
    state.successMessage = data;
    state.successMessage = state.successMessage.split("</br>").join("\n");
    state.successMessage = state.successMessage.split("<br/>").join("\n");
    state.successMessage = state.successMessage.split("<br>").join("\n");
  },

  expireAlert(state) {
    state.checkAlert = 0;
    state.successMessage = null;
    state.dangerMessage = null;
    state.warningMessage = null;
    state.infoMessage = null;
  },

  setLoading(state, data) {
    state.loadingCheck = data.status;
    state.loadingMessage = data.message;
  },

  setLoadingBtn(state, data) {
    state.loadingBtn = data;
  },

  setUpdateModule(state, data) {
    state.updateModule = state.updateModule + data;
  },

  changeThemeMode(state, data) {
    state.themeMode = data;
  },
  changeThemeColor(state, data) {
    state.themeMode = data;
  },
};
